import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-colors',
  templateUrl: './colors.component.html',
  styleUrl: './colors.component.scss',
  standalone: false
})
export class ColorsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
